<script setup lang="ts">
import { ref } from 'vue'
import Dialog from 'primevue/dialog'
import Textarea from 'primevue/textarea'
import Button from 'primevue/button'

const visible = ref(false)
const title = ref('')
const message = ref('')
const placeholder = ref('Enter your comment...')
const text = ref('')

let resolvePromise: ((value: string | null) => void) | null = null

function open(opts: {
  title: string
  message?: string
  placeholder?: string
}): Promise<string | null> {
  title.value = opts.title
  message.value = opts.message || ''
  placeholder.value = opts.placeholder || 'Enter your comment...'
  text.value = ''
  visible.value = true

  return new Promise<string | null>((resolve) => {
    resolvePromise = resolve
  })
}

function onConfirm() {
  visible.value = false
  resolvePromise?.(text.value || null)
  resolvePromise = null
}

function onCancel() {
  visible.value = false
  resolvePromise?.(null)
  resolvePromise = null
}

defineExpose({ open })
</script>

<template>
  <Dialog
    v-model:visible="visible"
    :header="title"
    modal
    :closable="true"
    class="w-full sm:w-30rem"
    @hide="onCancel"
  >
    <p v-if="message">{{ message }}</p>
    <Textarea
      v-model="text"
      :placeholder="placeholder"
      rows="4"
      fluid
      class="mt-3"
    />
    <template #footer>
      <Button label="Cancel" severity="secondary" @click="onCancel" />
      <Button label="Confirm" :disabled="!text.trim()" @click="onConfirm" />
    </template>
  </Dialog>
</template>
